<template>
  <el-tabs class="apply-admin">
    <el-tab-pane label="添加平台管理员">
      <el-form class="form" :model="form1" :rules="rules" ref="form1" label-width="80px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form1.name" placeholder="管理员姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="form1.gender">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form1.email" placeholder="邮箱" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form1.phone" placeholder="手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role_id">
          <el-select v-model="form1.role_id" placeholder="管理员角色" clearable>
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工号" prop="number">
          <el-input v-model="form1.number" placeholder="选填" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit1">立即添加</el-button>
        </el-form-item>
      </el-form>
      <p class="tips">提示：新增的管理员只允许使用手机号及邮箱登陆管理后台，登陆并绑定微信后才可使用扫码登陆功能</p>
    </el-tab-pane>
    <el-tab-pane label="添加机构管理员">
      <el-form class="form" :model="form2" :rules="rules" ref="form2" label-width="80px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form2.name" placeholder="管理员姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="form2.gender">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="机构" prop="partner_ids">
          <el-select v-model="form2.partner_ids" multiple placeholder="机构" clearable>
            <el-option
              v-for="item in partner"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form2.email" placeholder="邮箱" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form2.phone" placeholder="手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="工号" prop="number">
          <el-input v-model="form2.number" placeholder="选填" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit2">立即添加</el-button>
        </el-form-item>
      </el-form>
      <p class="tips">提示：新增的管理员只允许使用手机号及邮箱登陆管理后台，登陆并绑定微信后才可使用扫码登陆功能</p>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'ApplyAdmin',
  data () {
    let validateEamil = (rule, value, callback) => {
      let reg = new RegExp('^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)*.[a-zA-Z0-9]{2,6}$')
      if (value === '') {
        callback(new Error('请输入邮箱!'))
      } else if (!reg.test(value)) {
        callback(new Error('邮箱格式错误!'))
      } else {
        callback()
      }
    }

    let validatePhone = (rule, value, callback) => {
      let reg = new RegExp('^((1[0-9]))\\d{9}$')
      if (value === '') {
        callback(new Error('请输入手机号!'))
      } else if (!reg.test(value)) {
        callback(new Error('手机号格式错误!'))
      } else {
        callback()
      }
    }
    return {
      roles: [],
      partner: [],
      form1: {
        name: '',
        gender: '男',
        email: '',
        phone: '',
        role_id: '',
        number: ''
      },
      form2: {
        partner_ids: [],
        name: '',
        gender: '男',
        email: '',
        phone: '',
        number: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入管理员姓名', trigger: 'blur' }
        ],
        email: [
          { required: true, validator: validateEamil, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        role_id: [
          { required: true, message: '请选择管理员角色', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    let sendData = {
      type: 0
    }
    request({
      url: 'roles',
      method: 'get',
      params: sendData
    }).then(res => {
      this.roles = res.data.list
    })

    request({
      url: 'partners',
      method: 'get'
    }).then(res => {
      this.partner = res.data.list
    })
  },
  methods: {
    submit1 () {
      this.$refs['form1'].validate(valid => {
        if (valid) {
          this.applyAdmin1()
        } else {
          return false
        }
      })
    },
    submit2 () {
      this.$refs['form2'].validate(valid => {
        if (valid) {
          this.applyAdmin2()
        } else {
          return false
        }
      })
    },
    applyAdmin1 () {
      request({
        url: 'admins',
        method: 'post',
        data: this.form1
      }).then(res => {
        this.$message.success('添加成功')
        this.$refs['form1'].resetFields()
      })
    },
    applyAdmin2 () {
      request({
        url: 'partner-admins',
        method: 'post',
        data: this.form2
      }).then(res => {
        this.$message.success('添加成功')
        this.$refs['form2'].resetFields()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.form {
  width: 300px;
  .el-form-item {
    margin-bottom: 17px;
  }
}
.tips {
  color: red;
  font-size: 14px;
  margin-top: 20px;
  margin-bottom: 20px;
  text-indent: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/ApplyAdmin.vue